import { pilotTimeline } from '@wundo/shared/pilotTimeline.ts';

const WEEKDAYS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

/**
 * A `YYYY-MM-DD` day as `Monday 21 Sep 2026`.
 *
 * The names are spelled out rather than left to `Intl`, which abbreviates
 * September as "Sept" in every English locale it offers.
 */
export function formatPilotDate(date: string): string {
  const [year, month, day] = date.split('-').map(Number);
  if (!year || !month || !day) return date;

  const weekday = WEEKDAYS[new Date(Date.UTC(year, month - 1, day)).getUTCDay()];
  return `${weekday} ${day} ${MONTHS[month - 1]} ${year}`;
}

/** What a pilot's start date and length mean, in the console's own words. */
export function pilotExplanation(startAt: string, weeks: number): string {
  const timeline = pilotTimeline(startAt, weeks);

  return (
    'Every Monday at 08:00 (Brussels) each member gets the practice mail for that week. ' +
    `First mail: ${formatPilotDate(timeline.firstMailOn)} (week 1). ` +
    `Last: ${formatPilotDate(timeline.lastMailOn)} (week ${weeks}). ` +
    `On ${formatPilotDate(timeline.closingMailOn)} members get the closing mail; ` +
    `on ${formatPilotDate(timeline.accessEndsOn)} they lose access to Wundo.`
  );
}
